import { DateTime } from "luxon";
import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../..";

type GetCurrentStartEndDateSelectorReturn = (
  state: RootState,
) => [DateTime, DateTime | undefined] | undefined;

export const getDatesStateSelector = createSelector(
  (state: RootState) => state.dateSelectorState,
  (state) => state,
);

const getStartEndDates = createSelector(
  (state: RootState) => state.dateSelectorState,
  (state) => {
    return {
      startDate: state.startDate,
      endDate: state.endDate,
    };
  },
);

export const getCurrentStartEndDateSelector: GetCurrentStartEndDateSelectorReturn =
  createSelector(
    (state: RootState) => state.dateSelectorState,
    (state) => {
      if (state.startDate || state.endDate) {
        return [
          DateTime.fromFormat(state.startDate, "yyyy-MM-dd"),
          state.endDate
            ? DateTime.fromFormat(state.endDate, "yyyy-MM-dd")
            : undefined,
        ];
      }
      return undefined;
    },
  );

const getAvailabilitySelector = createSelector(
  (state: RootState) => state.dateSelectorState,
  (state) => state.availableSpaces,
);

export const datesStateSelectors = {
  currentStartEndDate: getCurrentStartEndDateSelector,
  datesState: getDatesStateSelector,
  startEndDates: getStartEndDates,
  availableSpaces: getAvailabilitySelector,
};
